export const SET_PAGE = 'consult-queue/SET_PAGE';
export const SET_PER_PAGE = 'consult-queue/SET_PER_PAGE';
export const APPLY_FILTERS = 'consult-queue/APPLY_FILTERS';
export const RESET_FILTERS = 'consult-queue/RESET_FILTERS';
